import React, { useState, useEffect } from "react";
 
const TypeWriter = ({ words, className = "" }) => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [blink, setBlink] = useState(true);
 
  useEffect(() => {
    if (index >= words.length) {
      setIndex(0);
      return;
    }
 
    const currentWord = words[index];
    const speed = isDeleting ? 60 : 120;
 
    const t = setTimeout(() => {
      if (!isDeleting) {
        setSubIndex((v) => v + 1);
        if (subIndex === currentWord.length) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        setSubIndex((v) => v - 1);
        if (subIndex === 0) {
          setIsDeleting(false);
          setIndex((v) => v + 1);
        }
      }
    }, speed);
 
    return () => clearTimeout(t);
  }, [subIndex, index, isDeleting, words]);
 
  useEffect(() => {
    const i = setInterval(() => setBlink((b) => !b), 500);
    return () => clearInterval(i);
  }, []);
 
  const displayText = words[index]?.substring(0, subIndex) || "";
 
  return (
    <span
      className={`inline-block ${className}`}
      style={{ borderRight: blink ? "2px solid #fff" : "2px solid transparent" }}
    >
      {displayText}
    </span>
  );
};
 
export default TypeWriter;